import { TextSize } from "component-utils/text-types";
import { styled } from "webapp/styled-components";

export const AvatarOverlayViewStyle = styled.div<{ textSize: TextSize }>`
    display: flex;
    align-items: center;

    pointer-events: none !important;

    ${p => (p.textSize === TextSize.Small ? p.theme.fontStyles.Header6 : p.theme.fontStyles.Header5)};

    > div {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .placeholder {
        background-color: ${p => p.theme.picker.backgroundColor};
    }

    .placeholder,
    > img,
    > canvas {
        width: ${p => (p.textSize === TextSize.Small ? 24 : 32)}px;
        height: ${p => (p.textSize === TextSize.Small ? 24 : 32)}px;
        border-radius: 100px;
        object-fit: cover;
        flex-shrink: 0;
        margin-right: 8px;
    }
`;
